<template>
  <v-flex sm12>
    <v-card flat class="tff-size-card">
      <v-layout justify-center pl-4 pt-3>
        <v-flex sm8 pb-4 pt-4 v-if="user">
          <v-layout row wrap justify-center fill-height align-center>
            <v-flex xs8 sm8 lg3 md3>
              <div style="position: relative;">
                <v-img
                  height="160px"
                  width="160px"
                  :src="user.image"
                  :style="`border-radius: 50%; border: 5px solid `+ user.color + ';'"
                  class=""
                >
                </v-img>
                <v-layout align-end justify-center row>
                  <img
                    height="40px"
                    width="40px"
                    src="@/assets/cumple.gif"
                    v-if="user.is_birthday"
                    style="position: absolute; bottom: -1rem; left: 4.4rem; "
                  />
                </v-layout>
              </div>
            </v-flex>
            <v-flex xs8 sm8 lg8 md8 pl-2>
              <v-flex sm12 pb-4>
                <v-layout row wrap>
                  <v-flex sm12 xs12>
                    <v-flex
                      text-18-security
                      font-weight-bold
                      grey-security
                    >{{user.full_name}}</v-flex>
                    <v-flex text-14-security grey-security>{{user.position}}</v-flex>
                  </v-flex>
                  <v-flex
                    xs12
                    sm12
                    text-14-security
                    font-weight-bold
                    grey-security
                  >{{user.company}}</v-flex>
                </v-layout>
                <v-layout row wrap class="mt-2">
                  <v-flex sm12 text-14-security grey-security class="tff-center-item">
                    <img class="material-icons" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/map-marker.svg" style="width: 17px" alt="address">
                    <span class="pl-1">{{user.address}}</span>
                  </v-flex>
                </v-layout> 
                <v-layout row wrap>
                  <v-flex sm12 text-14-security grey-security>
                    <a v-bind:href="`tel:${user.phone}`" class="email_phone tff-center-item">
                      <img class="material-icons" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/phone.svg" style="width: 17px" alt="phone">
                      <span class="pl-1">{{user.annexed}}</span>
                    </a>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex sm12 text-14-security grey-security>
                    <a v-bind:href="`mailto:${user.email}`" class="email_phone tff-center-item">
                      <img class="material-icons" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/email-outline.svg"  style="width: 17px" alt="email">
                      <span class="pl-1">{{ " " + user.email }}</span>
                    </a>
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex sm12 text-14-security grey-security v-show="user.birthday" class="tff-center-item">
                  <img  grey-security clas="colorp" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/cake-variant.svg"  style="width: 17px" alt="cake">
                    <span class="pl-1">{{user.birthday}}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-layout justify-start align-center style="gap: 10px;">
                <v-btn
                  color="#28385C"
                  class="white--text"
                  round
                  @click="handleCompanyChart()"
                >
                  <img src="@/assets/company-chart.svg" style="height: 1em;" class="pr-1" />
                  Ver Organigrama
                </v-btn>
                <v-btn
                  color="#505789"
                  class="white--text"
                  round
                  :href="`https://teams.microsoft.com/l/chat/0/0?users=${user.email}`"
                  target="_blank"
                >
                  <img src="@/assets/chat_teams.png" style="height: 1.5em;" />
                  <span class="ml-1">Iniciar Chat</span>
                </v-btn>
                <v-btn
                  color="grey darken-2"
                  v-if="currentUser.role.includes('super_admin') || currentUser.role.includes('admin') || currentUser.role.includes('to_see_how')"
                  round
                  class="white--text"
                  @click="changeUser"
                  :disabled="user.full_legal_number == 'sin rut'"
                >
                  Ver como
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    currentUser: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions("user", ["fetchCurrentUser", "fetchUser", "fetchCurrentUserParents", "fetchUserMessages", "showHideCompanyChart"]),
    ...mapActions("benefits", ["fetchBenefits"]),
    ...mapActions("api_menu", ["fetchMenu", "fetchFooterMenu"]),
    ...mapActions("posts", ["fetchImportantPosts"]),
    ...mapActions("galleries", ["fetchGalleries"]),
    ...mapActions("links",["fetchLinks"]),
    ...mapActions("menus", ["fetchPersonalBanking"]),
    ...mapActions("loading", ["startLoading", "stopLoading"]),
    async changeUser() {
      if (this.user.full_legal_number != "sin rut") {
        const ln = this.user.full_legal_number;
        localStorage.setItem("view_as", ln);
        try {
          this.startLoading();
          await this.fetchFooterMenu();
          await this.fetchMenu(ln);
          await this.fetchCurrentUser(ln);
          await this.fetchCurrentUserParents(ln);
          this.fetchImportantPosts(ln);
          this.fetchGalleries(ln);
          this.fetchLinks(ln);
          this.fetchUserMessages(ln);
          this.fetchPersonalBanking(ln);
        } catch (error) {
          console.error("Error al cambiar usuario:", error);
        } finally {
          this.stopLoading();
        }
        this.$router.push({ name: "profile" });
      }
    },
    handleCompanyChart() {
      this.showHideCompanyChart()
    }
  },
}
</script>

<style scoped>
@media screen and (min-width: 300px) and (max-width: 450px) {
  .tff-size-card{
    height: 560px;
  }
}

.profile {
  color: black;
  text-decoration: inherit;
  padding-left: 14px;
}
.color {
  color: grey;
}

#phone:hover {
  color: grey;
}
#email:hover {
  color: grey;
}
.user-profile {
  border: 3px solid rgb(1, 1, 151);
}

.message {
  color: black;
  text-decoration: inherit;
  cursor: pointer;
  font-size: 1.2em;
  font-weight: normal;
}

.tff-center-item {
  display: flex;
  align-items: center;
}

.email_phone {
  color: #515151;
  text-decoration: inherit;
}
</style>